/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { HalJson } from '../../models/hal-json';

export interface UsersUserIdDelete$Params {
  userId: string;
}

export function usersUserIdDelete(http: HttpClient, rootUrl: string, params: UsersUserIdDelete$Params, context?: HttpContext): Observable<StrictHttpResponse<{
'_links'?: HalJson;
}>> {
  const rb = new RequestBuilder(rootUrl, usersUserIdDelete.PATH, 'delete');
  if (params) {
    rb.path('userId', params.userId, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<{
      '_links'?: HalJson;
      }>;
    })
  );
}

usersUserIdDelete.PATH = '/users/{userId}';
